import api from '../utils/api';

export const getPatientsList = (config = {}) => {
    const { data, options } = config;
    return api({
        url: `api/composed/getpatientsbynameornumber/${data.data}`,
        method: "GET",
        data: data,
        ...options,
    });
}

export const getTemplateList = (config = {}) => {
    const { data, options } = config;
    return api({
        url: `api/messageTemplate/getAllMessageTemplate`,
        method: "GET",
        data: data,
        ...options,
    });
}


export const AddNewCompose = (config = {}) => {
    const { data, options } = config;
    return api({
        url: `api/composed/addcomposed`,
        method: "POST",
        data: data,
        ...options,
    });
}


export const getLocation = (config = {}) => {
    const { data, options } = config;
    return api({
        url: `api/composed/getlocationsbydaterange`,
        method: "POST",
        data: data,
        ...options,
    });
}

export const getPeopleByLocationId = (config = {}) => {
    const { data, options } = config;
    return api({
        url: `api/composed/getpatientsbydaterangelocationid`,
        method: "POST",
        data: data,
        ...options,
    });
}

export const getAllLocationOneTimeGroup = (config = {}) => {
    const { data, options } = config;
    return api({
        url: `api/composed/getAllLocationOneTimeGroup`,
        method: "GET",
        data: data,
        ...options,
    });
}